// noinspection TypeScriptValidateTypes

import vuetify from './vuetify'
import pinia from '../store'
import i18n from "./i18n";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {fas} from "@fortawesome/free-solid-svg-icons";
import {far} from "@fortawesome/free-regular-svg-icons";
import {fab} from "@fortawesome/free-brands-svg-icons";
import { createMetaManager, plugin as metaPlugin } from 'vue-meta'
import type { App } from 'vue'
import router from "@/router";

export function registerPlugins (app: App) {
  app.component('font-awesome-icon', FontAwesomeIcon) // Register component globally
  library.add(fas) // Include needed solid icons
  library.add(far) // Include needed regular icons
  library.add(fab) // Include needed brand icons

  app
    .use(i18n)
    .use(vuetify)
    .use(router)
    .use(pinia)
    .use(createMetaManager())
    .use(metaPlugin)
}
